var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.51755 0.2C2.37119 0.0885733 2.19717 0.0207191 2.01496 0.00404117C1.83276 -0.0126368 1.64958 0.0225203 1.48595 0.105573C1.32232 0.188626 1.18471 0.316293 1.08853 0.474269C0.99235 0.632245 0.941406 0.814289 0.941406 1V19C0.941406 19.1857 0.99235 19.3678 1.08853 19.5257C1.18471 19.6837 1.32232 19.8114 1.48595 19.8944C1.64958 19.9775 1.83276 20.0126 2.01496 19.996C2.19717 19.9793 2.37119 19.9114 2.51755 19.8L14.3386 10.8C14.461 10.7069 14.5603 10.5861 14.6287 10.4472C14.6971 10.3084 14.7327 10.1552 14.7327 10C14.7327 9.84476 14.6971 9.69164 14.6287 9.55279C14.5603 9.41393 14.461 9.29315 14.3386 9.2L2.51755 0.2Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.258c46acbc1a4996fa2a9a756bc86790.svg";
export { ForwardRef as ReactComponent };